module.exports = new __parcel__URL__("meditation.fafafa26.png").toString();